/* Carpe Ice verlanglijst (okt 2026)
   - Gasten: lijst in localStorage (ci_wl).
   - Ingelogd: lijst in het klantaccount via /apps/verlanglijst (app proxy -> Oxygen -> klantmetaveld).
   - Bij inloggen wordt de gastenlijst samengevoegd met de accountlijst.
   - Bij uitloggen wordt de lokale kopie van de accountlijst gewist (gedeelde apparaten). */
(function () {
  if (window.__ciWlInit) return;
  window.__ciWlInit = true;

  var C = window.ciWl || { t: {} };
  var KEY = 'ci_wl', OWNER = 'ci_wl_owner', SYNC = 'ci_wl_sync';
  var PROXY = '/apps/verlanglijst';
  var MAX = 100;
  var cid = C.customer ? String(C.customer) : null;
  var pending = 0;
  var synced = !cid;

  function get(k, store) { try { return (store || localStorage).getItem(k); } catch (e) { return null; } }
  function set(k, v, store) { try { if (v === null) (store || localStorage).removeItem(k); else (store || localStorage).setItem(k, v); } catch (e) {} }

  var list = [];
  try { list = JSON.parse(get(KEY) || '[]'); } catch (e) { list = []; }
  if (!Array.isArray(list)) list = [];
  list = list.filter(function (i) { return i && /^\d+$/.test(String(i.id)); }).map(function (i) { return { id: String(i.id), handle: i.handle || '' }; });

  function save() { set(KEY, JSON.stringify(list)); }
  function has(id) { id = String(id); return list.some(function (i) { return i.id === id; }); }

  function render() {
    var btns = document.querySelectorAll('[data-ci-wl]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i], on = has(b.getAttribute('data-ci-wl'));
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (C.t.add) b.setAttribute('aria-label', on ? C.t.remove : C.t.add);
      var tx = b.querySelector('[data-ci-wl-text]');
      if (tx && C.t.save) tx.textContent = on ? C.t.saved : C.t.save;
    }
    var counts = document.querySelectorAll('[data-ci-wl-count]');
    for (var j = 0; j < counts.length; j++) {
      counts[j].textContent = list.length > 99 ? '99+' : String(list.length);
      counts[j].classList.toggle('is-visible', list.length > 0);
    }
    document.dispatchEvent(new CustomEvent('ci-wl:change', { detail: { list: list.slice() } }));
  }

  function api(method, body) {
    var opt = { method: method, credentials: 'same-origin', headers: { accept: 'application/json' } };
    if (body) { opt.headers['content-type'] = 'application/json'; opt.body = JSON.stringify(body); }
    return fetch(PROXY + (method === 'GET' ? '?t=' + Date.now() : ''), opt).then(function (r) {
      if (!r.ok) throw new Error('wl ' + r.status);
      return r.json();
    });
  }

  function fromServer(d) {
    if (!d || !Array.isArray(d.items) || pending > 0) return;
    list = d.items.map(function (i) { return { id: String(i.id), handle: i.handle }; });
    save(); render();
  }

  function track(on, id, handle) {
    try {
      if (on && window.dataLayer) window.dataLayer.push({ event: 'add_to_wishlist', ecommerce: { items: [{ item_id: id, item_name: handle }] } });
    } catch (e) {}
  }

  function toggle(btn) {
    var id = String(btn.getAttribute('data-ci-wl'));
    var handle = btn.getAttribute('data-handle') || '';
    var on = has(id);
    if (on) list = list.filter(function (i) { return i.id !== id; });
    else list = [{ id: id, handle: handle }].concat(list).slice(0, MAX);
    save(); render();
    if (!on) { btn.classList.remove('ci-wl-pop'); void btn.offsetWidth; btn.classList.add('ci-wl-pop'); }
    track(!on, id, handle);
    if (cid) {
      pending++;
      api('POST', { action: on ? 'remove' : 'add', ids: [id] })
        .then(function (d) { pending--; fromServer(d); })
        .catch(function () { pending--; });
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ci-wl]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  }, true);

  function done() { if (!synced) { synced = true; render(); } }
  function fail() { /* server onbereikbaar: synced blijft uit, zodat de pagina de kaarten uit het account laat staan */ }

  function sync() {
    var owner = get(OWNER);
    if (!cid) {
      // Uitgelogd: lijst van een account niet laten staan op dit apparaat.
      if (owner) { list = []; save(); set(OWNER, null); set(SYNC, null, sessionStorage); render(); }
      return;
    }
    if (owner !== cid) {
      // Net ingelogd (of ander account): gastenlijst samenvoegen, oudste eerst zodat de nieuwste bovenaan blijft.
      var ids = owner ? [] : list.map(function (i) { return i.id; }).reverse();
      (ids.length ? api('POST', { action: 'merge', ids: ids }) : api('GET')).then(function (d) {
        set(OWNER, cid); set(SYNC, String(Date.now()), sessionStorage); synced = true; fromServer(d); done();
      }).catch(fail);
      return;
    }
    var last = Number(get(SYNC, sessionStorage) || 0);
    // Op de verlanglijstpagina altijd verversen; elders hooguit eens per 5 minuten.
    if (!document.querySelector('[data-ci-wl-page]') && Date.now() - last < 5 * 60 * 1000) return done();
    api('GET').then(function (d) { set(SYNC, String(Date.now()), sessionStorage); synced = true; fromServer(d); done(); }).catch(fail);
  }

  // Kaarten die later in de pagina komen (filters, oneindig scrollen, snel kopen) ook bijwerken.
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var a = muts[i].addedNodes;
      for (var j = 0; j < a.length; j++) {
        var n = a[j];
        if (n.nodeType === 1 && (n.matches('[data-ci-wl]') || n.querySelector('[data-ci-wl]'))) { render(); return; }
      }
    }
  });

  window.ciWishlist = { list: function () { return list.slice(); }, has: has, render: render, synced: function () { return synced; } };

  function start() {
    render();
    // Eerste weergave zonder animatie; daarna mogen hartje en teller weer animeren (zie ci-wishlist.css).
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { document.documentElement.classList.add('ci-wl-ready'); });
    });
    mo.observe(document.body, { childList: true, subtree: true });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();